module.exports = __webpack_public_path__ + "static/martal-9a7788d4d690c6b0caff84be0e0d2b8d.png";